import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import BASE_QUERY from '@/features/baseQuery';

// Creating an API service using RTK Query
export const propertiesApi = createApi({
	reducerPath: 'propertiesApi',
	tagTypes: ['PROPERTIES'],
	baseQuery: fetchBaseQuery(BASE_QUERY),
	endpoints: (builder) => ({
		insightEndpoint: builder.query({
			providesTags: (result, error, arg) => [{ type: 'PROPERTIES', id: arg.endpoint }],
			query: ({ endpoint, ...data }) => ({
				url: `${process.env.REACT_APP_MISC_API_ENDPOINT}/v1${endpoint}`,
				method: 'POST',
				body: data,
			}),
			transformResponse: (response) => {
				// console.log('👾 ~ Transform insightEndpoint data', response);
				return response;
			},
			transformErrorResponse: (error) => {
				console.error('Error with insightEndpoint data', error);
				return error;
			},
		}),
		// Returns the Insight record itself, e.g. { IndustryType: {...} } -> {...}
		getInsightObjectById: builder.query({
			providesTags: (result, error, arg) => [
				{ type: 'PROPERTIES', id: `${arg.objectType}-${arg.id}` },
			],
			query: ({ objectType, id }) => ({
				url: `${process.env.REACT_APP_MISC_API_ENDPOINT}/v1/${objectType}/${id}`,
				method: 'GET',
			}),
			transformResponse: (response, meta, arg) => response?.[arg.objectType],
		}),
	}),
});

// Exporting auto-generated hooks for the defined endpoints
export const {
	useInsightEndpointQuery,
	useLazyInsightEndpointQuery,
	useGetInsightObjectByIdQuery,
	useLazyGetInsightObjectByIdQuery,
} = propertiesApi;
